import { Element, Node } from 'slate';

export type HeadingLevel = 1 | 2 | 3 | 4 | 5 | 6;

export type CoverageRule = { kind: 'block' } | { kind: 'strict' } | { kind: 'all-cells' };

export interface Coverage {
  rule: CoverageRule;
}

export interface CoverageMarked {
  coverage: Coverage;
}

export const hasCoverage = (node: Node): node is Node & CoverageMarked => Element.isElement(node) && (node as { coverage?: Coverage }).coverage !== undefined;

export const HEADING_FORMATS: Record<string, HeadingLevel> = {
  h1: 1,
  'heading-1': 1,
  'heading-one': 1,
  h2: 2,
  'heading-2': 2,
  'heading-two': 2,
  h3: 3,
  'heading-3': 3,
  'heading-three': 3,
  h4: 4,
  'heading-4': 4,
  'heading-four': 4,
  h5: 5,
  'heading-5': 5,
  'heading-five': 5,
  h6: 6,
  'heading-6': 6,
  'heading-six': 6,
};

export const getHeadingLevel = (node: Node): HeadingLevel | null => {
  if (!Element.isElement(node)) return null;
  const formatting = (node as { formatting?: { format?: string } }).formatting;
  if (!formatting?.format) return null;
  return HEADING_FORMATS[formatting.format] ?? null;
};

export const isHeading = (node: Node): boolean => getHeadingLevel(node) !== null;

export const isReferenceTable = (node: Node): boolean => Element.isElement(node) && (node as { type: string }).type === 'reference-table';
